var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5901",
    "data-name": "Group 5901",
    transform: "translate(-310 -15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6739",
    "data-name": "Rectangle 6739",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(310 15)",
    fill: "#056069"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6740",
    "data-name": "Rectangle 6740",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(310 24)",
    fill: "#056069"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6741",
    "data-name": "Rectangle 6741",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(310 33)",
    fill: "#056069"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.6f8e4196.svg";
export { ForwardRef as ReactComponent };